import React from "react";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTitle } from "../utils/useTitle";

/**
 * Mission Statement Component
 * this component renders the mission statement text
 * 
 * @returns {JSX.Element} Mission Statement Component
 */
export function MissionStatement() {
  useTitle("Mission Statement");
  const { t } = useTranslation();

  return (
    <>
      <Grid container 
        spacing={4} 
        sx={{ 
          marginTop: "50px",
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Grid item xs={6}>
          <Typography
            variant="h3"
            fontWeight={800}
            color={"green"}
            textAlign={"center"}
          >
            {t("mission.header")}
          </Typography>

          <img
            src="/assets/images/banner1.jpg"
            alt="banner"
            style={{
              width: "100%",
              height: "150px", 
              objectFit: "cover",
              borderRadius: "8px", 
              marginTop: "20px",
            }}
          />
          <Typography
            variant="h6"
            fontWeight={400}
            marginTop={"30px"}
            textAlign={"justify"}
          >
            {t("mission.paragraph1")}
          </Typography>

          <Typography
            variant="h6"
            fontWeight={400}
            marginTop={"30px"}
            textAlign={"justify"}
          >
            {t("mission.paragraph2")}
          </Typography>
          
        </Grid>
      </Grid>
    </>
  );
};
